import React from 'react';
import {observer} from 'mobx-react';
import {auth} from 'main/tools';
import {FormattedMessage} from 'react-intl';
import {Avatar, Button} from 'shared/components';
import BrandedContainer from '../../../../BrandedContainer';

const marketingCopy = (invite) => ({
  info: <FormattedMessage id='user_signup.signup.partner.HR_INFO' values={{companyName: invite.companyName}}/>,
  header: <FormattedMessage id='user_signup.signup.partner.HR_HEADER'/>
});

const PartnerAcceptInvitation = observer(({uiState}) => {
  const {invite} = uiState;
  const user = auth.user;

  return (
    <BrandedContainer {...marketingCopy(invite)}>
      <div className='center mb3'>
        <div className='wl-big-logo mx-auto'></div>
      </div>
      <div className='h2 medium center mb2'>
        <FormattedMessage id='user_signup.signup.partner.Accept Invitation'/>
      </div>
      <div className='jumbo center mb3'>
        <FormattedMessage id='user_signup.signup.partner.HR_INVITATION' values={{companyName: invite.companyName}}/>
      </div>
      <div className='bg-haze rounded p3 mb3 border'>
        <div className='h4 medium mb2'>
          <FormattedMessage id='user_signup.signup.partner.Logged in as'/>
        </div>
        <div className='flex items-center'>
          <div className='mr2'>
            <Avatar employee={user} size='sm'/>
          </div>
          <div>
            <div>{user.name}</div>
            <div className='jumbo'>{user.email}</div>
          </div>
        </div>
      </div>
      <Button className='full-width' onClick={() => uiState.signUp()}>
        <FormattedMessage id='user_signup.signup.partner.Accept Invitation'/>
      </Button>
    </BrandedContainer>
  );
});

export default PartnerAcceptInvitation;
